import { requestHelpers } from '../../../../../helpers';
import {updateTodoList} from '../../../../../actions/todo_list/todo_list';

export const actions = {
    SET_INVESTMENTS: "SET_INVESTMENTS",
    GENERAL_INVESTMENTS_REQUEST: "GENERAL_INVESTMENTS_REQUEST",
    GENERAL_INVESTMENTS_SUCCESS: "GENERAL_INVESTMENTS_SUCCESS",
    GENERAL_INVESTMENTS_ERROR: "GENERAL_INVESTMENTS_ERROR",
    SET_INVESTMENTS_LIST: "SET_INVESTMENTS_LIST",
}

export const setInvestments = ( profile ) => {
    const noData = !profile.investments[0];
    return {
        type: actions.SET_INVESTMENTS,
        personId: profile.id,
        range: profile.investments[0] ? profile.investments[0].common_investment.range : '',
        investment_id: profile.investments[0] ? profile.investments[0].investment_id : '',
        noData,
    }
}

export const changeInvestments = ( personId, payload, type ) => {
    const requestType = !payload.investment_id ? 'DELETE' : ( type ?  'POST' : 'PUT');

    return (dispatch) => {
        requestHelpers
            .authenticatedPostRequest(`/profiles/${personId}/investment`, payload, requestType )
            .then((response) => {
                return dispatch({
                    type: actions.GENERAL_INVESTMENTS_REQUEST,
                    payload,
                })
            }).catch((error) => console.log( 'LOG: error', error  ));
      dispatch(updateTodoList(personId, 8));
    }
};


export const getInvestmentsList = () => {
    return (dispatch) => {
        requestHelpers
            .authenticatedGetRequest( `/common/investments` )
            .then((response) => {
                return dispatch({
                    type: actions.SET_INVESTMENTS_LIST,
                    ranges: response.data,
                })
            })
    }
}


// WEBPACK FOOTER //
// src/client/components/site/features/profile/actions/investments.js